/**
 * Loader
 * A plugin that displays a loader in a DOM node.
 * @version 3.0.0
 */

const loaderStr =
	'<span class="loader"><span class="usability--visuallyhidden">${screenreaderText}</span></span>';
const loaderLargeStr =
	'<span class="loader loader--large"><span class="usability--visuallyhidden">${screenreaderText}</span></span>';
const loaderSmallStr =
	'<span class="loader loader--small"><span class="usability--visuallyhidden">${screenreaderText}</span></span>';

/**
 * Start loading.
 * @param {Object} el - A DOM node.
 * @param {String} screenreaderText - A string containing a text for screenreaders.
 * @param {String} size - The size as a string ('large' for a large loader, 'small' för a small loader, anything else for a standard loader).
 * @public
 */
export const loadingStart = (el, screenreaderText, size, storeInnerHtml) => {
	let loaderString = loaderStr;

	if (screenreaderText === undefined) {
		screenreaderText = '';
	}

	if (size !== undefined && size === 'small') {
		loaderString = loaderSmallStr;
	} else if (size !== undefined && size === 'large') {
		loaderString = loaderLargeStr;
	}

	loaderString = loaderString.replace('${screenreaderText}', screenreaderText);

	if (storeInnerHtml !== undefined) {
		el.setAttribute('data-innerhtml', el.innerHTML);
	}

	el.innerHTML = loaderString;
};

/**
 * Stop loading.
 * @param {Object} el - A DOM node.
 * @public
 */
export const loadingEnd = el => {
	let oldHtml = el.getAttribute('data-innerhtml');

	if (oldHtml !== null) {
		el.innerHTML = el.getAttribute('data-innerhtml');
	}
};
